// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1-gZW","subheader":"ReorderModal_subheader__3KsZ2","listWrap":"ReorderModal_listWrap__9chyo"};